<template>
  <div class="not-found-page">
    <div class="centered">
      <h1><i class="not-found-icon nc-icon nc-puzzle-10"></i>404</h1>
      <h3>{{ $t('page404.info') }}</h3>
      <div v-if="$auth.check()">
        <h5><a :href="$route.query.path">{{ $route.query.path }}</a></h5>
      </div>
      <div v-else>
        <h5>{{ $route.path }}</h5>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "not-found",
  components: {
  }
};
</script>
<style lang="scss">
.not-found-page {
  .full-page > .content,
  .centered {
    min-height: calc(100vh - 160px);
  }

  .not-found-icon {
    margin-right: 10px;
  }

  .centered {
    h1,
    i {
      font-size: 50px;
    }

    p {
      font-size: 20px;
    }

    display: flex;
    padding-bottom: 150px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: white;
  }
}
</style>
